import { Component } from '@angular/core';
import { EstadoSolicitudCredito } from 'src/app/models/enum/estado-solicitud-credito.enum';
import { SolicitudCredito } from 'src/app/models/solicitud-credito.model';
import { DataService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SolicitudDetalleComponent } from '../solicitud-detalle/solicitud-detalle.component';
import { OfertaCredito } from 'src/app/models/oferta-credito.model';
import { CambioEstadoService } from 'src/app/services/cambio-estado.service';
import { AuthService } from '@auth0/auth0-angular';
import { EstadoOfertaCredito } from 'src/app/models/enum/estado-oferta-credito';
import { MatTooltip } from '@angular/material/tooltip';
import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { Fireworks } from 'fireworks-js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  solicitudes: SolicitudCredito[] = [];
  ofertas: OfertaCredito[] = [];
  solicitudCreditoId!: string;
  solicitudActiva: SolicitudCredito | null = null;
  tieneSolicitudActiva: boolean = false; 
  noOfertas: boolean = true;
  desabilitarBoton: boolean = true;
  showFireworks: boolean = false;
  constructor(private dataService: DataService,private router: Router,  private dialog: MatDialog,private cambioEstadoService: CambioEstadoService, private auth:AuthService ) { }

  ngOnInit(): void {
    this.getSolicitudes();
    
    this.auth.idTokenClaims$.subscribe({
      next: (r) => {
        this.cambioEstadoService.startConnection(r?.__raw);
        this.cambioEstadoService.onEstadoActualizado((id: string) => {
          console.log('Estado actualizado en solicitud:', id);
          this.getSolicitudes();
        });
      }
    });
  }

  normalize(value: string | undefined): string {
    return (value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '')
        .toLowerCase();
  }
  
  getSolicitudes() {
    const url = 'solicitud-credito';
    this.dataService.getData(url).subscribe({
      next: (data: SolicitudCredito[]) => {
        console.log(data);
        this.solicitudes = data
        .sort((a, b) => new Date(b.fechaSolicitud).getTime() - new Date(a.fechaSolicitud).getTime())
        .slice(0, 1);
        if (this.solicitudes.length > 0) {
          this.solicitudActiva = this.solicitudes[0];
          if (this.solicitudActiva && this.solicitudActiva.guid) {
            this.isSolicitudActiva();
            this.solicitudCreditoId = this.solicitudActiva.guid;
            this.desabilitarBoton = !(this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.PendienteRevision));
            if (this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.PendienteSeleccionOfertaUsuario) 
              || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador)) 
            {
              console.log('obteniendo las ofertas')
              this.getOfertas();
            }
            if(this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador)){
              console.log('Lanzando fuegos artificiales');
              this.showFireworks = true;
              setTimeout(() => this.launchFireworks(), 0);
            }
          }
        }
      },
      error: (error) => {
        console.error('Error al obtener las solicitudes:', error);
      }
    });
  }

  agregarDias(fecha: Date | string, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() + dias);
    return nuevaFecha;
  }

  verDetalle(solicitud: any) {
    const dialogRef = this.dialog.open(SolicitudDetalleComponent, {
      width: '600px',
      height: '600px',
      data: solicitud
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El modal se cerró');
    });
  }


  cancelarSolicitud(solicitud: any) {
    var url = "solicitud-credito/" + solicitud.guid
    solicitud.estadoSolicitudCredito = 'CanceladaUsuario';
    this.desabilitarBoton = true;

    this.dataService.updateData(solicitud, url).subscribe({
      next: (v) => {
        console.log(v)
      },
      error: (e) => {
        console.log(e);
      }
    })
    this.tieneSolicitudActiva = false;
  }

getSemaforoClass(estado: EstadoSolicitudCredito): String {
  switch (this.normalize(estado)) {
    case this.normalize(EstadoSolicitudCredito.PendienteRevision):
      return 'pendiente-revision';
    case this.normalize(EstadoSolicitudCredito.PendienteDocumentacion):
      return 'pendiente-documentacion';
    case this.normalize(EstadoSolicitudCredito.Ofertada):
      return 'ofertada';
    case this.normalize(EstadoSolicitudCredito.PendienteSeleccionOfertaUsuario):
      return 'pendiente-seleccion-oferta-usuario';
    case this.normalize(EstadoSolicitudCredito.FinalizadaConGanador):
      return 'finalizada-con-ganador';
    case this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador):
      return 'finalizada-sin-ganador';
    case this.normalize(EstadoSolicitudCredito.CanceladaUsuario):
      return 'cancelada-usuario';
    case this.normalize(EstadoSolicitudCredito.Caducada):
      return 'caducada';
    default:
      return '';
  }
}

  get colorCreada(): string {
    if (this.solicitudActiva) {
      return 'estado-verde';
    }
    return 'estado-creada';
  }

  get colorRevision(): string {
    if (this.solicitudActiva && this.normalize(this.solicitudActiva.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.Ofertada)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.PendienteSeleccionOfertaUsuario)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador))
    {
      return 'estado-verde';
    }
    return 'estado-amarillo';
  }

  get colorOfertada(): string {
    if (this.solicitudActiva && this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.Ofertada)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.PendienteSeleccionOfertaUsuario)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador))
    {
      return 'estado-verde';
    }
    return 'estado-ofertada';
  }
  
  get colorPendienteSeleccion(): string {
    if (this.solicitudActiva && this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.PendienteSeleccionOfertaUsuario)) {
      return 'estado-amarillo';
    }else if (this.solicitudActiva && this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador) || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador)) {
      return 'estado-verde';
    }
    return 'estado-ofertada';
  }


  get colorFinalizada(): string {
    if (this.solicitudActiva && this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaConGanador) || this.normalize(this.solicitudActiva?.estadoSolicitudCredito) === this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador)) {
      return 'estado-verde';
    }
    return 'estado-finalizada';
  }


  getOfertas(): void {
    if (this.solicitudActiva) {
      console.log(this.solicitudCreditoId)
      const url = 'solicitud-credito/' + this.solicitudCreditoId + '/ofertas';
      this.dataService.getData(url).subscribe({
        next: (data: OfertaCredito[]) => {
          const estado =  Object.keys(EstadoOfertaCredito);
          this.ofertas = data.filter(oferta => estado.indexOf(oferta.estadoOfertaCredito) === estado.indexOf('AprobadaSupervisor') || estado.indexOf(oferta.estadoOfertaCredito) === estado.indexOf('AceptadaCliente'));
          this.ofertas.sort((a, b) => a.rankingActual - b.rankingActual);
          this.noOfertas = this.ofertas.length === 0; 
          console.log(this.ofertas);
        },
        error: (error) => {
            console.error('Error al cargar las ofertas', error);
            this.noOfertas = true;
        },
        complete: () => {
          console.log('Carga de ofertas completada');
        }
      });
    }
  }

  isSolicitudActiva(): boolean {
    if (this.normalize(this.solicitudActiva?.estadoSolicitudCredito)==this.normalize(EstadoSolicitudCredito.FinalizadaConGanador)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito)==this.normalize(EstadoSolicitudCredito.FinalizadaSinGanador)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito)==this.normalize(EstadoSolicitudCredito.CanceladaUsuario)
      || this.normalize(this.solicitudActiva?.estadoSolicitudCredito)==this.normalize(EstadoSolicitudCredito.Caducada)
      || (!this.solicitudActiva)
  ){
    this.tieneSolicitudActiva=false;
  }else{
    this.tieneSolicitudActiva=true;
  }
    return this.tieneSolicitudActiva;
  }

  launchFireworks() {
    const container = document.querySelector('.fireworks-container') as HTMLElement;

    if (!container) {
      console.error('Contenedor de fuegos artificiales no encontrado');
      return;
    }

    const fireworks = new Fireworks(container, {
      autoresize: false,
      opacity: 0.5,
      acceleration: 1.05,
      friction: 0.97,
      gravity: 1.5,
      particles: 50,
      traceLength: 1,
      explosion: 2,
      intensity: 20,
      flickering: 30,
      lineStyle: 'round',
      hue: {
        min: 0,
        max: 360
      },
      delay: {
        min: 30,
        max: 60
      },
      rocketsPoint: {
        min: 50,
        max: 50
      },
      lineWidth: {
        explosion: {
          min: 1,
          max: 3
        },
        trace: {
          min: 1,
          max: 2
        }
      },
      brightness: {
        min: 50,
        max: 80
      },
      decay: {
        min: 0.015,
        max: 0.03
      },
      mouse: {
        click: false,
        move: false,
        max: 1
      }
    });

    fireworks.start();

    setTimeout(() => {
      fireworks.stop();
      this.showFireworks = false;
    }, 120000); 
  }
}